(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sr-Cyrl", [], factory);
	else if(typeof exports === 'object')
		exports["sr-Cyrl"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["sr-Cyrl"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 